var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"content body-content "},[_c('div',{staticClass:"panel panel-body trix-output",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }